import * as yup from 'yup';
import { aceite } from './utils/rulesByKey';

export const AutopatrocinioSchema = yup.object({
  ...aceite,
});

export const AutopatrocinioInitialValues = {
  aceite: false,
};
